import { defineComponent } from 'vue';
import m1 from '/src/images/googlemaps/m1.png';
import m2 from '/src/images/googlemaps/m2.png';
import m3 from '/src/images/googlemaps/m3.png';
import m4 from '/src/images/googlemaps/m4.png';
import m5 from '/src/images/googlemaps/m5.png';

export default defineComponent({
  delimiters: ['${', '}'],
  data() {
    return {
      openedMarker: {
        id: null,
        stockist: null,
      },
      clusterStyles:[
        {
          textColor: 'black',
          url: m1,
          height: 52,
          width: 53,
        },
        {
          textColor: 'black',
          url: m2,
          height: 55,
          width: 56,
        },
        {
          textColor: 'black',
          url: m3,
          height: 65,
          width: 66,
        },
        {
          textColor: 'black',
          url: m4,
          height: 77,
          width: 78,
        },
        {
          textColor: 'black',
          url: m5,
          height: 89,
          width: 90,
        },
      ],
      isGoogleAvailable: false,
    };
  },
  computed: {
    markers() {
      return this.$store.getters.markers;
    },
    stockists() {
      return this.$store.getters.stockists;
    },
    center() {
      return this.$store.getters.map.center;
    },
    zoom() {
      return this.$store.getters.map.zoom;
    },
  },
  mounted() {
    // Save google map instance to root vue instance
    this.$root.setGoogleMap(this.$refs.googleMap);
    this.$refs.googleMap.$mapPromise.then(() => this.$root.setIsGoogleAvailable(true));
  },
  methods: {
    markerClick(id: number) {
      this.$store.commit('setMapCenter', id);
      this.$store.commit('setMapZoom', 14);
      const stockistList = this.$root.$refs.stockistList;
      const stockistListItemEl = stockistList.$refs[`stockistListItem-${id}`][0];
      const top = (stockistListItemEl.offsetTop - stockistList.$el.offsetTop) + 1;
      stockistList.$el.scrollTo({ top, behavior: 'smooth', });
      const stockistListItemAccordionRef = stockistList.$refs[`stockistListItemAccordion-${id}`][0];
      stockistListItemAccordionRef.opened = true;
      this.openMarker(id);
    },
    openMarker(id: number) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const stockist = this.stockists.filter((item: any) => item.id === id)[0];
      this.openedMarker = {
        id,
        stockist,
      };
    },
  },
  template: '#t-stockist-map',
});
